
<template>
  <div> 
       <Header />

       <div class="md-layout md-alignment-center">
         <div class="md-layout-item md-size-50">
           <h1>Recorrências</h1>
           <Search @search="search" />
           <Table :items="items" />
         </div>
       </div>
  </div>
</template>

<script>

import Header from '@/components/HeaderCompany.vue'

import Table from './components/Table.vue'
import Search from './components/Search.vue';


import {mapState, mapActions} from 'vuex'


export default {
  components: {
    Header,
    Table,
    Search,
  },
  computed:{
    ...mapState("CompanyRecurrent", ["items"])
  },
  methods:{
    ...mapActions("CompanyRecurrent",["setList"]), 
    search(params){
        this.setList(params);    
    },
         
  },
  mounted(){    
      this.setList();    
  }
}
</script>
